// extracted by mini-css-extract-plugin
module.exports = {"ButtonsContainer":"styles_ButtonsContainer__R1g3t"};